import {
  Action,
  Condition,
  DimmerStatus,
  SceneLightState,
  SceneObjectType,
  Trigger,
} from '@/../client-generator/generated-clients/plants';
import { PropType } from 'vue';
import { Vue, Options } from 'vue-class-component';
import { SceneWizardStepEnum } from '../SceneWizardStep';
import TriggerAndConditionDateTime from './TriggerAndConditionDateTime/TriggerAndConditionDateTime.vue';
import TriggerAndConditionLight from './TriggerAndConditionLight/TriggerAndConditionLight.vue';
import TriggerAndConditionLightDimmer from './TriggerAndConditionLightDimmer/TriggerAndConditionLightDimmer.vue';
import TriggerAndConditionBlind from './TriggerAndConditionBlind/TriggerAndConditionBlind.vue';
import TriggerAndConditionSocket from './TriggerAndConditionSocket/TriggerAndConditionSocket.vue';
import TriggerAndConditionLock from './TriggerAndConditionLock/TriggerAndConditionLock.vue';
import TriggerAndConditionShutter from './TriggerAndConditionShutter/TriggerAndConditionShutter.vue';
import TriggerAndConditionThermostat from './TriggerAndConditionThermostat/TriggerAndConditionThermostat.vue';

@Options({
  name: 'DialogAddTriggerAndCondition',
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    stepToAdd: {
      required: true,
      type: Number,
    },
    triggerOrActionToAdd: {
      type: [Object as PropType<Trigger | Condition>, null],
    },
    triggerOrConditionType: {
      type: Number,
    },
    triggerOrConditionName: {
      type: String,
    },
  },
  watch: {
    isVisible: function (newValue) {
      this.isDialogVisible = newValue;
    },
    isDialogVisible: function (newValue) {
      this.$emit('update:isVisible', newValue);
    },
  },
  components: {
    TriggerAndConditionLight,
    TriggerAndConditionLightDimmer,
    TriggerAndConditionBlind,
    TriggerAndConditionSocket,
    TriggerAndConditionLock,
    TriggerAndConditionShutter,
    TriggerAndConditionThermostat,
    TriggerAndConditionDateTime,
  },
  emits: ['confirm', 'update:isVisible'],
})
export default class DialogAddTriggerAndCondition extends Vue {
  SceneObjectType = SceneObjectType;
  SceneLightState = SceneLightState;
  DimmerStatus = DimmerStatus;

  isVisible!: boolean;
  stepToAdd!: SceneWizardStepEnum;
  triggerOrActionToAdd!: Trigger | Action;
  triggerOrConditionType!: SceneObjectType;
  triggerOrConditionName!: string;
  isDialogVisible = false;
  confirmDisabled = false;

  get headerName() {
    return this.triggerOrConditionName;
  }

  get actionComponent() {
    switch (this.triggerOrConditionType) {
      case SceneObjectType.Light:
      case SceneObjectType.GeneralCommandsLights:
      case SceneObjectType.GroupOfLights: {
        return 'TriggerAndConditionLight';
      }
      case SceneObjectType.Dimmer: {
        return 'TriggerAndConditionLightDimmer';
      }
      case SceneObjectType.Shutter:
      case SceneObjectType.GeneralCommandsShutters:
      case SceneObjectType.GroupOfShutters: {
        return 'TriggerAndConditionShutter';
      }
      case SceneObjectType.Thermostat: {
        return 'TriggerAndConditionThermostat';
      }
      case SceneObjectType.Lock: {
        return 'TriggerAndConditionLock';
      }
      case SceneObjectType.DateTime: {
        return 'TriggerAndConditionDateTime';
      }
      case SceneObjectType.TowelWarmer: {
        return ''; //TODO: real component
      }
      case SceneObjectType.Fancoil: {
        return ''; //TODO: real component
      }
      case SceneObjectType.Blind: {
        return 'TriggerAndConditionBlind';
      }
      case SceneObjectType.Socket: {
        return 'TriggerAndConditionSocket';
      }
      default:
        return '';
    }
  }

  mounted() {
    this.isDialogVisible = this.isVisible;
  }

  doHideDialog() {
    this.isDialogVisible = false;
  }

  doConfirm() {
    this.$emit('confirm');
    this.doHideDialog();
  }

  updateConfirmDisabled(newValue: boolean) {
    this.confirmDisabled = newValue;
  }
}
